import { Theme } from "../../../components/constants";

export default {
	text: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
	actionsRow: {
		display: 'flex',
		flexDirection: 'row-reverse',
		gap: '20px'
	},
	noticeName: {
		textDecoration: 'underline',
		cursor: 'pointer'
	},
	horizontalPaddingForHorizontalProgress: {
		padding: '0px 20px'
	},
	popupCustomStyle: {
		maxHeight: "95vh",
		minHeight: "200px",
		display: "flex",
		flexDirection: "column",
		width: '50vw',
		maxWidth: '50vw'
	},
	popupChildrenStyles: {
		maxHeight: "100%",
		padding: '50px',
		paddingTop: '10px',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'space-between',
		flex: 1,
	},
	addEditPopup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '50px'
	},
	addEditPopupInputRow: {
		display: 'flex',
		gap: '10px',
		alignItems: 'center'
	},
	addEditPopupRow: {
		display: 'flex',
		gap: '10px',
		justifyContent: 'flex-end'
	}
}